import axios from "axios";

const baseUrL = process.env.REACT_APP_BASE_URL;

const getFilename = (value) => {
  if (!value || typeof value !== "string") {
    return "";
  }
  const clean = value.split("?")[0];
  const parts = clean.split("/");
  return parts[parts.length - 1] || "";
};

/**
 * Builds a browser URL for a client's stored logo using the API base URL.
 */
export const getClientLogoSrc = (client) => {
  if (!client) {
    return "";
  }

  const filename = getFilename(client.logo) || getFilename(client.logoUrl);
  if (!filename) {
    return "";
  }

  return `${baseUrL}/media/client-logo/${filename}`;
};

/**
 * Uploads a company logo for a client. Used after create/update so the JSON
 * client APIs stay unchanged.
 */
export const uploadClientLogo = async (clientId, file, authToken) => {
  if (!clientId || !file) {
    return;
  }

  const data = new FormData();
  data.append("logo", file);

  await axios.post(`${baseUrL}/admin/clients/${clientId}/logo`, data, {
    headers: {
      Authorization: authToken,
    },
  });
};
